import * as React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';

const ProductTitle = ({ record }) => {
  return <span>Product {record ? `"${record.type}"` : 'Not Foundd'}</span>;
};

export const ProductEdit = (props) => (
  <Edit title={<ProductTitle />} {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput disabled source="type" />
      <TextInput disabled source="scenario" />
      <TextInput disabled source="purchaseType" />
      <TextInput source="price" />
      <TextInput source="priceUnit" />
      <TextInput source="num" />
      <TextInput source="description" />
    </SimpleForm>
  </Edit>
);
